import { IEnvConfig } from 'interfaces/i-env-config';
import { LoginMethod } from 'lib_ts/enums/auth.enums';
import { LanguageCode } from 'lib_ts/enums/translation';

export const ENV_LOCAL: IEnvConfig = {
  identifier: 'local',
  maintenance: false,
  strict: true,
  use_radix: true,

  production: false,
  languages: [LanguageCode.English, LanguageCode.Japanese, LanguageCode.Korean],

  debug_messages: true,
  region_redirect: true,
  run_tests: false,

  self_url: 'http://localhost:4000',
  server_url: 'http://localhost:3000',
  ws_url: 'http://localhost:8030/users',
  ws_path: undefined,

  login_methods: [LoginMethod.Auth0, LoginMethod.Legacy],

  liveboard_url: 'http://localhost:5173',

  enable: {
    change_language: true,

    vitals: false,

    sample_lists: true,

    toggle_rapid: true,

    pitch_upload_avg_release: true,
    pitch_upload_avg_chars: true,

    toggle_plate_shots: true,
    toggle_plate_debug: true,
    toggle_plate_safety_controls: true,
    toggle_plate_ellipses: true,
  },

  integrations: {
    intercom_app_id: 'tas54ol3',

    auth0: {
      domain: 'trajektsports.us.auth0.com',
      audience: 'https://trajektsports.us.auth0.com/api/v2/',
      clientId: '7EdcjlhpQ8V80kWMQOpOR1he3PzTx5NH',
    },

    sentry: {
      enabled: false,
      dsn: 'https://d788b74980a6ee68987343d048d92b41@o4509952079429632.ingest.us.sentry.io/4509967840378880',
      environment: 'local',
      trace_sample_rate: 0,
    },
  },
};
